<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Өргөдөл гомдол / Ажилтантай холбоотой" />
    <div class="content-body">
        <div class="container pd-0-f">тун удахгүй</div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components:{
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
}
</script>

<style>

</style>